import { useEffect, useRef } from "react";

const useSmoothSectionScroll = (containerRef) => {
  const isScrollingRef = useRef(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const sections = Array.from(container.querySelectorAll("section"));

    const handleWheel = (e) => {
      if (isScrollingRef.current) return;

      e.preventDefault();
      const delta = Math.sign(e.deltaY);
      const scrollTop = container.scrollTop;
      const sectionHeight = container.clientHeight;

      let currentIndex = sections.findIndex(
        (sec) => Math.abs(sec.offsetTop - scrollTop) < sectionHeight * 0.5
      );

      // Fallback if no section matched exactly
      if (currentIndex === -1) {
        currentIndex = 0;
      }

      const nextIndex = Math.min(
        sections.length - 1,
        Math.max(0, currentIndex + delta)
      );

      const targetOffset = sections[nextIndex].offsetTop;

      isScrollingRef.current = true;
      container.scrollTo({ top: targetOffset, behavior: "smooth" });

      setTimeout(() => {
        isScrollingRef.current = false;
      }, 1000);
    };

    container.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      container.removeEventListener("wheel", handleWheel);
    };
  }, [containerRef]);
};

export default useSmoothSectionScroll;
